import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function AddressInfo({
  addressName,
  handleChange,
  values
 }) {
  const city = addressName + ".city";
  const county = addressName + ".county";
  const address = addressName + ".address1";

  return (
    <>
      <Form.Group as={Row} controlId={city}>
        <Form.Label column sm={3}>
          İl
        </Form.Label>
        <Col sm={9}>
          <Form.Control type="text" value={values.city} placeholder="İl" onChange={handleChange} />
        </Col>
      </Form.Group>
                      
      <Form.Group as={Row} controlId={county}>
        <Form.Label column sm={3}>
          İlçe
        </Form.Label>
        <Col sm={9}>
          <Form.Control type="text" value={values.county} placeholder="İlçe" onChange={handleChange} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId={address}>
        <Form.Label column sm={3}>
          Adres
        </Form.Label>
        <Col sm={9}>
          <Form.Control type="text" value={values.address1} placeholder="Adres" onChange={handleChange} />
        </Col>
      </Form.Group>
    </>        
  );
}